import { useState } from "react";
export function useAuth() {
  const [user] = useState<{ id: string; email: string } | null>(null);
  return { user, isLoading: false, isAuthenticated: !!user, logout: () => {} };
}
